/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListUnresolvedVendorErrorCodesResponseDto,
  UnresolvedVendorErrorCodeRemarkActionRequestDto,
  UnresolvedVendorErrorCodeResponseDto,
  UpdateUnresolvedVendorErrorCodeRequestDto,
} from '../models/index';
import {
    ListUnresolvedVendorErrorCodesResponseDtoFromJSON,
    ListUnresolvedVendorErrorCodesResponseDtoToJSON,
    UnresolvedVendorErrorCodeRemarkActionRequestDtoFromJSON,
    UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSON,
    UnresolvedVendorErrorCodeResponseDtoFromJSON,
    UnresolvedVendorErrorCodeResponseDtoToJSON,
    UpdateUnresolvedVendorErrorCodeRequestDtoFromJSON,
    UpdateUnresolvedVendorErrorCodeRequestDtoToJSON,
} from '../models/index';

export interface UnresolvedVendorErrorCodeControllerFindAllRequest {
    limit: number;
    page: number;
    sortOrder?: UnresolvedVendorErrorCodeControllerFindAllSortOrderEnum;
    status?: string;
    assetTypeId?: string;
    manufacturerId?: string;
    q?: string;
}

export interface UnresolvedVendorErrorCodeControllerFindByIdRequest {
    id: string;
}

export interface UnresolvedVendorErrorCodeControllerIgnoreRequest {
    id: string;
    unresolvedVendorErrorCodeRemarkActionRequestDto: UnresolvedVendorErrorCodeRemarkActionRequestDto;
}

export interface UnresolvedVendorErrorCodeControllerResolveRequest {
    id: string;
    unresolvedVendorErrorCodeRemarkActionRequestDto: UnresolvedVendorErrorCodeRemarkActionRequestDto;
}

export interface UnresolvedVendorErrorCodeControllerUnignoreRequest {
    id: string;
    unresolvedVendorErrorCodeRemarkActionRequestDto: UnresolvedVendorErrorCodeRemarkActionRequestDto;
}

export interface UnresolvedVendorErrorCodeControllerUpdateRequest {
    id: string;
    updateUnresolvedVendorErrorCodeRequestDto: UpdateUnresolvedVendorErrorCodeRequestDto;
}

/**
 * 
 */
export class ErrorManagementUnresolvedVendorErrorCodesApi extends runtime.BaseAPI {

    /**
     */
    async unresolvedVendorErrorCodeControllerFindAllRaw(requestParameters: UnresolvedVendorErrorCodeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUnresolvedVendorErrorCodesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling unresolvedVendorErrorCodeControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling unresolvedVendorErrorCodeControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['assetTypeId'] != null) {
            queryParameters['assetTypeId'] = requestParameters['assetTypeId'];
        }

        if (requestParameters['manufacturerId'] != null) {
            queryParameters['manufacturerId'] = requestParameters['manufacturerId'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListUnresolvedVendorErrorCodesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerFindAll(requestParameters: UnresolvedVendorErrorCodeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUnresolvedVendorErrorCodesResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerFindByIdRaw(requestParameters: UnresolvedVendorErrorCodeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnresolvedVendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unresolvedVendorErrorCodeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnresolvedVendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerFindById(requestParameters: UnresolvedVendorErrorCodeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnresolvedVendorErrorCodeResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerIgnoreRaw(requestParameters: UnresolvedVendorErrorCodeControllerIgnoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnresolvedVendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unresolvedVendorErrorCodeControllerIgnore().'
            );
        }

        if (requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'unresolvedVendorErrorCodeRemarkActionRequestDto',
                'Required parameter "unresolvedVendorErrorCodeRemarkActionRequestDto" was null or undefined when calling unresolvedVendorErrorCodeControllerIgnore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes/{id}/ignore`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSON(requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnresolvedVendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerIgnore(requestParameters: UnresolvedVendorErrorCodeControllerIgnoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnresolvedVendorErrorCodeResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerIgnoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerResolveRaw(requestParameters: UnresolvedVendorErrorCodeControllerResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnresolvedVendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unresolvedVendorErrorCodeControllerResolve().'
            );
        }

        if (requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'unresolvedVendorErrorCodeRemarkActionRequestDto',
                'Required parameter "unresolvedVendorErrorCodeRemarkActionRequestDto" was null or undefined when calling unresolvedVendorErrorCodeControllerResolve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSON(requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnresolvedVendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerResolve(requestParameters: UnresolvedVendorErrorCodeControllerResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnresolvedVendorErrorCodeResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerResolveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerUnignoreRaw(requestParameters: UnresolvedVendorErrorCodeControllerUnignoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnresolvedVendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unresolvedVendorErrorCodeControllerUnignore().'
            );
        }

        if (requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'unresolvedVendorErrorCodeRemarkActionRequestDto',
                'Required parameter "unresolvedVendorErrorCodeRemarkActionRequestDto" was null or undefined when calling unresolvedVendorErrorCodeControllerUnignore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes/{id}/unignore`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnresolvedVendorErrorCodeRemarkActionRequestDtoToJSON(requestParameters['unresolvedVendorErrorCodeRemarkActionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnresolvedVendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerUnignore(requestParameters: UnresolvedVendorErrorCodeControllerUnignoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnresolvedVendorErrorCodeResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerUnignoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerUpdateRaw(requestParameters: UnresolvedVendorErrorCodeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnresolvedVendorErrorCodeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unresolvedVendorErrorCodeControllerUpdate().'
            );
        }

        if (requestParameters['updateUnresolvedVendorErrorCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateUnresolvedVendorErrorCodeRequestDto',
                'Required parameter "updateUnresolvedVendorErrorCodeRequestDto" was null or undefined when calling unresolvedVendorErrorCodeControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/unresolved-vendor-error-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUnresolvedVendorErrorCodeRequestDtoToJSON(requestParameters['updateUnresolvedVendorErrorCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnresolvedVendorErrorCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async unresolvedVendorErrorCodeControllerUpdate(requestParameters: UnresolvedVendorErrorCodeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnresolvedVendorErrorCodeResponseDto> {
        const response = await this.unresolvedVendorErrorCodeControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UnresolvedVendorErrorCodeControllerFindAllSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type UnresolvedVendorErrorCodeControllerFindAllSortOrderEnum = typeof UnresolvedVendorErrorCodeControllerFindAllSortOrderEnum[keyof typeof UnresolvedVendorErrorCodeControllerFindAllSortOrderEnum];
